// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"e8d5fa7b","339":"79cd1e37","479":"8b139fd3","520":"ac105b0b","527":"867cc911","682":"ab90d3d1","964":"9d9bd5a1"}[chunkId] + ".chunk.js";
};